import { render, staticRenderFns } from "./OutdatedBanner.vue?vue&type=template&id=aef8720c&scoped=true&"
import script from "./OutdatedBanner.vue?vue&type=script&lang=js&"
export * from "./OutdatedBanner.vue?vue&type=script&lang=js&"
import style0 from "./OutdatedBanner.vue?vue&type=style&index=0&id=aef8720c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aef8720c",
  null
  
)

export default component.exports